// extracted by mini-css-extract-plugin
export default {"root":"NewBeneficiary_root__wZdYc","error":"NewBeneficiary_error__mpTKG","form":"NewBeneficiary_form__sp-Iy","input":"NewBeneficiary_input__pgud8"};